<template>
    <v-list dense nav class="pt-2">
        <template v-for="tab in visibleTabs">
            <v-divider v-if="tab.showDividerBefore" :key="`divider-${tab.name}`" class="my-2"></v-divider>
            <v-list-item
                :key="tab.name"
                :input-value="isActiveTab(tab)"
                :disabled="tab.disabled"
                :data-tour="getTourAttribute(tab.name)"
                link
                @click="$emit('navigate', tab)"
            >
                <v-list-item-icon>
                    <v-icon>{{ tab.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ tab.name }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="getTabBadgeCount(tab) > 0" class="my-0">
                    <v-chip x-small color="error" text-color="white">
                        {{ getTabBadgeCount(tab) }}
                    </v-chip>
                </v-list-item-action>
            </v-list-item>
        </template>
    </v-list>
</template>

<script>
export default {
    name: 'MainSidebar',
    props: {
        tabs: { type: Array, required: true },
        hasAccess: { type: Function, required: true },
        isActiveTab: { type: Function, required: true },
        getTabBadgeCount: { type: Function, required: true },
        getTourAttribute: { type: Function, required: true },
    },
    computed: {
        // Flags each tab with whether a group divider belongs before it,
        // based on group changes between consecutively *visible* tabs.
        visibleTabs() {
            const visible = this.tabs.filter(this.hasAccess);
            return visible.map((tab, index) => ({
                ...tab,
                showDividerBefore: index > 0 && tab.group !== visible[index - 1].group,
            }));
        },
    },
};
</script>
